import { render } from "./page4.vue?vue&type=template&id=38bb7911&scoped=true"
import script from "./page4.vue?vue&type=script&lang=js"
export * from "./page4.vue?vue&type=script&lang=js"

import "./page4.vue?vue&type=style&index=0&id=38bb7911&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38bb7911"]])

export default __exports__